<template>
  <div
    class="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-12 gap-6 py-8 md:py-10 px-4 xl:px-0"
  >
    <!-- Left Sidebar -->
    <div class="order-2 md:order-1 md:col-span-4 lg:col-span-3">
      <LeftsideBarVue />
    </div>

    <!-- Right column: article + "Continue reading" (keeps both columns the same height) -->
    <div class="order-1 md:order-2 md:col-span-8 lg:col-span-9 flex flex-col gap-6">
    <div
      class="card p-6 sm:p-8 md:p-12 gsap-detail"
    >
      <div v-if="editorial">
        <!-- Header -->
        <div
          class="flex flex-col sm:flex-row sm:items-end gap-6 md:gap-8 mb-8 pb-8 border-b border-gray-100 gsap-header"
        >
          <!-- Profile Image -->
          <img
            :src="getImage(editorial.image_url)"
            @error="onImageError"
            alt="Editorial"
            class="w-44 h-44 md:w-56 md:h-56 object-cover rounded-md shadow-md ring-4 ring-white"
          />

          <!-- Title Section -->
          <div>
            <h2
              class="font-serif text-3xl md:text-4xl font-bold text-gray-900 leading-tight"
            >
              {{ editorial.title }}
            </h2>

            <p class="mt-2 text-base md:text-lg text-brand-red-dark font-medium">
              {{ editorial.subtitle }}
            </p>

            <div class="mt-4 w-14 h-1 rounded-full bg-brand-red"></div>
          </div>
        </div>

        <!-- Description -->
        <div class="gsap-desc">
          <p
            class="prose-text md:text-[17px] max-w-3xl"
          >
            {{ editorial.description }}
          </p>
        </div>
      </div>

      <!-- Loading -->
      <div v-else class="flex flex-col items-center gap-3 text-gray-500 font-medium py-16">
        <div class="animate-spin rounded-full h-9 w-9 border-2 border-gray-200 border-t-brand-red"></div>
        Loading...
      </div>
    </div>

    <ContinueReading :exclude="$route.params.id" />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import LeftsideBarVue from "@/components/LeftsideBar.vue";
import ContinueReading from "@/components/ContinueReading.vue";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: "EditorialDetail",
  components: { LeftsideBarVue, ContinueReading },

  data() {
    return {
      editorial: null,
    };
  },

  methods: {
    async fetchEditorialDetails() {
      const id = this.$route.params.id;
      this.editorial = null;
      window.scrollTo(0, 0);

      try {
        const res = await axios.get(
          `${process.env.VUE_APP_API_BASE_URL}/editorials/${id}`
        );
        this.editorial = res.data;

        this.$nextTick(() => {
          this.animateEditorial();
        });
      } catch (err) {
        console.error("Failed to fetch editorial details:", err);
      }
    },

    animateEditorial() {
      // Reset only this page's animations; killing every ScrollTrigger would
      // leave other v-reveal elements on the page stuck invisible
      if (this.gsapCtx) this.gsapCtx.revert();

      this.gsapCtx = gsap.context(() => {
        gsap.from(".gsap-detail", {
          opacity: 0,
          y: 40,
          duration: 0.8,
          ease: "power2.out",
        });

        gsap.from(".gsap-header", {
          opacity: 0,
          y: 20,
          duration: 1,
          delay: 0.2,
        });

        gsap.from(".gsap-desc", {
          scrollTrigger: {
            trigger: ".gsap-desc",
            start: "top 85%",
            toggleActions: "play none none none",
          },
          opacity: 0,
          y: 30,
          duration: 1,
        });
      }, this.$el);
    },

    getImage(img) {
      return require(`@/assets/images/${img}`);
    },

    onImageError(event) {
      event.target.src = "";
    },
  },

  mounted() {
    this.fetchEditorialDetails();
  },

  beforeUnmount() {
    if (this.gsapCtx) this.gsapCtx.revert();
  },

  watch: {
    "$route.params.id": "fetchEditorialDetails",
  },
};
</script>
